import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

// Shared state across all interceptor calls
let isRefreshing = false;
const refreshSubject = new BehaviorSubject<boolean>(false);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.url.startsWith('https://api.ipify.org')) {
        return next(req);
    }

    // Toujours envoyer les cookies
    const reqWithCredentials = req.clone({ withCredentials: true });

    // Ne pas intercepter les endpoints auth
    if (req.url.includes('/api/auth/')) {
        return next(reqWithCredentials);
    }

    const authService = inject(AuthService);

    return next(reqWithCredentials).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status !== 401) {
                return throwError(() => error);
            }

            // 401 reçu — essayer de rafraîchir le token
            if (isRefreshing) {
                // Un refresh est déjà en cours — attendre
                return refreshSubject.pipe(
                    filter(done => done === true),
                    take(1),
                    switchMap(() => next(reqWithCredentials))
                );
            }

            isRefreshing = true;
            refreshSubject.next(false);

            return authService.refreshAccessToken().pipe(
                switchMap(() => {
                    isRefreshing = false;
                    refreshSubject.next(true);
                    return next(reqWithCredentials);
                }),
                catchError(refreshError => {
                    isRefreshing = false;
                    refreshSubject.next(false);
                    authService.logout();
                    return throwError(() => refreshError);
                })
            );
        })
    );
};
